<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import getLanguage from './utils/getLanguage';

export default {
  created() {
    this.$store.commit('setLanguage', {
      language: getLanguage(),
    });
  },
};
</script>

<style lang="less">
@import url('./style/common.less');

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
